/**
 * defa.routers.InvitationRouter
 * The router for the InvitationController
 * @version 1.0.0
 */
const InvitationRouter = Mn.AppRouter.extend({
		
		// ------------------------------------------------
		// Setup
		// ------------------------------------------------
		
	appRoutes : {
		'invitations/:context/:email/:token(/)'    : 'showInvitationsWithToken',
	},
		
		
		
		// ------------------------------------------------
		// Event Handlers
		// ------------------------------------------------
		
		// ------------------------------------------------
		// Other functions
		// ------------------------------------------------
		
});
	
export default InvitationRouter;
